<template>
  <v-container fluid v-resize="onResize">
    <v-data-table
        dense
        :headers="getColumns"
        :items="itemList"
        item-key="id"
        class="elevation-7"
        :options.sync="options"
        :server-items-length="totalRecords"
        @update:options="updateOptions"
        :loading="loading"
        :footer-props="{
            'items-per-page-options': [-1, 20, 50, 100, 250]
          }"
        :height="windowSize.y - subtractHeight"
        fixed-header
        :item-class="itemRowBackground"
        hide-default-footer
    >
      <template v-slot:top>
        <v-toolbar ref="RefListTop" height="64" v-if="userId === null">
          <v-container fluid>
            <v-row>
              <v-text-field
                  v-model="searchTerm"
                  label="Search user"
                  clearable
                  @input="onUpdateSearchTerm"
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-checkbox
                  v-model="onlyActiveUser"
                  label="only active user"
                  @change="onUpdateFilters"
              ></v-checkbox>
              <v-spacer></v-spacer>
              <HumanUserNewEditDialog></HumanUserNewEditDialog>
            </v-row>
          </v-container>
        </v-toolbar>

      </template>
      <template v-slot:item.edit="{ item }">
        <HumanUserNewEditDialog :item="item"></HumanUserNewEditDialog>
      </template>
      <template v-slot:item.active="{ item }">
        <v-simple-checkbox :value="item.active"></v-simple-checkbox>
      </template>
      <template v-slot:item.visible="{ item }">
        <v-simple-checkbox :value="item.visible"></v-simple-checkbox>
      </template>
      <template v-slot:item.created_on="{ item }">
        <span v-if="item.created_on">{{ item.created_on | moment("DD.MM.YYYY HH:mm:ss") }}</span>
      </template>
      <template v-slot:item.edited_on="{ item }">
        <span v-if="item.edited_on">{{ item.edited_on | moment("DD.MM.YYYY HH:mm:ss") }}</span>
      </template>
      <template v-slot:item.created_by="{ item }">
        <span v-if="item.created_by">{{ item.created_by.username }}</span>
      </template>
      <template v-slot:item.edited_by="{ item }">
        <span v-if="item.edited_by">{{ item.edited_by.username }}</span>
      </template>
    </v-data-table>
    <HumanUserConfirmDialog store-name="Contract"></HumanUserConfirmDialog>
    <router-view></router-view>
  </v-container>
</template>

<script>
import {debounce} from "debounce"
import {mapGetters, mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import HumanUserNewEditDialog from "@/components/TimeTracker/HumanUserNewEditDialog";
import HumanUserConfirmDialog from "@/components/TimeTracker/HumanUserConfirmDialog";

export default {
  name: 'HumanUser',
  props: {
    subtractHeight: {type: [Number], default: 150},
    height: {type: [Number], default: window.innerHeight},
    userId: {type: [Number], default: null},
  },

  components: {
    HumanUserNewEditDialog,
    HumanUserConfirmDialog,
  },

  computed: {
    ...mapGetters('HumanUser', ['getColumns']),
    ...mapFields('HumanUser', ['message_error', 'options', 'totalRecords', 'options.page', 'onlyFailedView', 'briefView', 'itemList',
      'loading', 'deleteLoading', 'updateLoading', 'restoring', 'selectedItemList', 'searchTermFile', 'searchTerm',
      'isAlive', 'action_loading', 'filters', 'local_phrase']),
    ...mapFields('HRDepartment', {itemListDepartment: 'itemList'},),
  },
  watch: {},

  methods: {
    ...mapActions('HumanUser', ['openWebSocket', 'fetchItemList', 'fetchItem', 'fetchDeleteSelectedItem',
      'fetchSyncNotionSelectedItems', 'fetchRestoreSelectedItems', 'fetchSaveItemField', 'fetchOrderItemList',
      'fetchActionSelectedItem', 'fetchActionItem']),
    ...mapActions('HRDepartment', {fetchItemListDepartment: 'fetchItemList'}),

    onResize() {
      this.windowSize = {x: window.innerWidth, y: window.innerHeight};
    },

    itemRowBackground: function (item) {
      // console.log('row click', item)
      if (item.error_message != null)
        return "event_error"
      else
        return "event_" + item.event
    },

    getEventColor: function (item) {
      return this.local_phrase[item.event].color
    },

    updateOptions() {
      // console.log('updateOptions', this.userId)
      this.fetchItemList({to_consumer: this.dto_model, from_consumer: this.dto_model})
    },

    onUpdateFilters() {
      // console.log('updateOptions', this.userId, this.filterEvents, this.startMonth, this.endMonth)
      this.options.page = 1

      this.filters = {}
      if (this.userId != null)
        this.filters = {user_id: this.userId}
      if (this.onlyActiveUser === true)
        this.filters['only_active_user'] = true

      this.fetchItemList({to_consumer: this.dto_model, from_consumer: this.dto_model})
    },

    onRemoveItems() {
      this.fetchDeleteSelectedItem()
    },

    onUpdateSearchTerm: debounce(function () {
      // console.log('onUpdateSearchTerm', this.filters)
      this.options.page = 1
      this.fetchItemList({to_consumer: this.dto_model, from_consumer: this.dto_model})
    }, 800),

    statusColor() {
      if (this.search_status === 'OK')
        return 'success'
      if (this.search_status === 'NOK')
        return 'error'
      return 'primary'
    },
  },

  async mounted() {
    // console.log('mounted')
    this.briefView = this.userId != null
    this.searchTerm = null
    this.onUpdateFilters()
    if (this.itemListDepartment.length === 0)
      await this.fetchItemListDepartment({to_consumer: 'HumanDepartmentDTO', from_consumer: 'HumanDepartmentDTO'})
  },

  data() {
    return {
      dto_model: 'HumanUserDTO',
      localFilterDate: this.date,
      windowSize: {x: 0, y: 0,},
      userSelected: null,
      filterEvents: [],
      eventsList: ['tracker', 'working', 'pause', 'time_correction', 'holiday', 'holiday_extra', 'sick', 'sick_with_child'],
      errorMessageFilter: false,
      uncheckedFilter: false,
      deletedFilter: false,
      startMonth: null,
      endMonth: null,
      onlyActiveUser: true,
    }
  }
}
</script>

<style>
.row_even {
  background-color: white !important;
}

.event_working, .event_work_kug {
  background-color: #E3F2FD !important;
}

.event_time_correction {
  background-color: #E1F5FE !important;
}

.event_holiday, .event_holiday_extra {
  background-color: #E8F5E9 !important;
}

.event_sick, .event_sick_with_child, .event_sick_kug {
  background-color: #FFF8E1 !important;
}

.event_error {
  background-color: #FFEBEE !important;
}

</style>
